'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import controller from './controller';
exports.default = {
  restrict: 'E',
  bindings: {},
  template: _template2.default,
  controller: function controller() {}

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-mode/index.js
 **/